import Layout from "@/components/layout/layout"
import 'bootstrap/dist/css/bootstrap.min.css'
import "@/assets/css/all.min.css"
import "@/assets/css/style.css"
import "@/assets/css/responsive.css"
import AnimationProvider from "@/components/layout/animationProvider"
import type { AppProps } from "next/app"
import Head from "next/head"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";


export default function App({ Component, pageProps }: AppProps) {

    const [queryClient] = useState(() => new QueryClient());

  return (
    <Layout>
       <Head>
        <title>Ashva Education</title>
        <link rel="icon" href="/images/common/favicon.ico" />  
      </Head>
      <AnimationProvider>
            <QueryClientProvider client={queryClient}>
                 <Component   {...pageProps} />
                </QueryClientProvider>
      </AnimationProvider>  
    </Layout>
    
  ) 
}
